import { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGlobalStore } from '@digiwedge/global-state';

type Props = { children?: ReactNode };

export function Protected({ children }: Props) {
  const token = useGlobalStore((s) => s.token);
  const bypass = String(import.meta.env.VITE_BYPASS_AUTH ?? '') === '1';
  const loc = useLocation();

  if (!token && !bypass) {
    const redirectTo = encodeURIComponent(`${loc.pathname}${loc.search}`);
    return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
  }
  return children ? (children as JSX.Element) : <Outlet />;
}
